module.exports = __webpack_public_path__ + "b6c3b32690526da33e78fada7fd510fc.pdf";